import React from "react";
const noop = () => {
    if (process.env.NODE_ENV !== "test") {
        console.warn("Failed to get context. Make sure you wrap your application with <MarketProvider>");
    }
};
const defaultContext = {
    getMarketFromLanguage: noop,
    getMarketFromLocale: noop,
    getMarketFromLocation: noop,
    guessMarketFromLanguages: noop,
    generateUrl: noop,
};
export default React.createContext(defaultContext);
